import { Controller } from "@hotwired/stimulus"

// 予約確定があるイベントの編集で、開催日時・開催形式・開催場所を変えて保存しようとしたら、
// 予約者への周知が必要なことを確認ダイアログで伝える。キャンセルしたら送信しない。
// 予約者への周知（イベント情報変更メール）は Phase 4 で足す。ここでは警告だけ出す。
//
// 比べるのは保存済みの値（originalValue。Customer::EventsHelper#reservation_change_warning_data）。
// 入力欄の初期値と比べないのは、検証エラーで再表示した画面では初期値が送信した値に置き換わり、
// 保存済みの値から変わっていても警告が出なくなるため。
export default class extends Controller {
  static values = { reservedCount: Number, original: Object }

  confirm(event) {
    if (!this.changed) return

    const message = `予約確定が${this.reservedCountValue}件あります。開催日時・開催場所・開催形式を変更する場合は、予約者への周知が必要です。保存しますか？`
    if (!window.confirm(message)) event.preventDefault()
  }

  get changed() {
    return Object.entries(this.originalValue).some(([name, original]) => this.isChanged(name, original))
  }

  // NOTE: 開催形式はラジオボタンなので、elements で取ると RadioNodeList になり、value は選ばれているものの値になる。
  isChanged(name, original) {
    const field = this.element.elements[`event[${name}]`]
    if (!field) return false

    if (name.endsWith("_at")) {
      return this.time(field.value) !== this.time(original)
    } else {
      return field.value.trim() !== (original ?? "").trim()
    }
  }

  // NOTE: 入力欄の値は秒が0なら秒を省く（"2026-11-01T10:00"）ので、文字列ではなく時刻で比べる。
  time(value) {
    return value ? new Date(value).getTime() : null
  }
}
